import React from 'react';
import './Itinerary.css';

const Itinerary = ({ userEvent }) => {
  // Houston event details
  const renderHoustonEvents = () => (
    <div className="timeline">
      {/* Houston Event */}
      <div className="event-day houston-event-itinerary">
        <div className="event-day-header">
          <h3 className="day-title">SATURDAY, NOVEMBER 29, 2025</h3>
        </div>
        <div className="event-day-content">
          <div className="event-left">
            <h2 className="event-name">HOUSTON RECEPTION</h2>
          </div>
          <div className="event-right">
            <p className="event-description">Join us for a celebration of our marriage in Houston.</p>
            <p className="event-time">6pm to 10pm</p>
            <p className="event-dress">Formal</p>
            <p className="event-location-text">Location: White Oaks on the Bayou</p>
            <p className="event-location-text"><a href='https://maps.app.goo.gl/X1iG4Z6eoNP1Ekic6'>7920 Farm to Market 1489, Simonton, TX 77476</a></p>
          </div>
        </div>
      </div>
    </div>
  );

  // Cancun event details
  const renderCancunEvents = () => (
    <div className="timeline">
      {/* Friday Event */}
      <div className="event-day friday-event">
        <div className="event-day-header">
          <h3 className="day-title">FRIDAY, DEC 5</h3>
        </div>
        <div className="event-day-content">
          <div className="event-left">
            <h2 className="event-name">PITHI + WELCOME PARTY</h2>
          </div>
          <div className="event-right">
            <p className="event-description">Join us for our Pithi as we welcome you all for the weekend!</p>
            <p className="event-time">6pm to 9pm</p>
            <p className="event-dress">Dress in Casual Traditional or Casual</p>
          </div>
        </div>
        <div className="event-icons">
            <img src="/images/icon/event-icon.png" alt="Event decorations" />
        </div>
      </div>

      {/* Saturday Event */}
      <div className="event-day saturday-event">
        <div className="event-day-content">
          <div className="event-left">
            <h3 className="day-title saturday-day-title">SATURDAY, DEC 6</h3>
            <h2 className="event-name">SANGEETH</h2>
          </div>
          <div className="event-right">
            <p className="event-description">Get ready for a night of celebration, dancing and partying!</p>
            <p className="event-time">6pm to 11pm</p>
            <p className="event-dress">Dress in Indian Traditional</p>
          </div>
        </div>
      </div>

      {/* Sunday Events */}
      <div className="event-day sunday-event">
        <div className="event-day-header">
          <h3 className="day-title">Sunday, Dec 7</h3>
        </div>
        <div className="event-day-content">
          <div className="event-left">
            <h2 className="event-name">WEDDING CEREMONY</h2>
          </div>
          <div className="event-right">
            <p className="event-description">Join us as we exchange vows and begin our journey together.</p>
            <p className="event-time">1pm</p>
            <p className="event-dress">Formal</p>
          </div>
        </div>

        <div className="event-day-content second-event">
          <div className="event-left">
            <h2 className="event-name">WEDDING RECEPTION</h2>
          </div>
          <div className="event-right">
            <p className="event-description">Dinner</p>
            <p className="event-time">5pm</p>
            <p className="event-dress">Formal</p>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="page-container itinerary-container">
      {userEvent === 'Houston' && (
        <>
          <h1>Houston Wedding Reception</h1>
          {renderHoustonEvents()}
        </>
      )}

      {userEvent === 'Cancun' && (
        <>
          <h1>Cancun Wedding Itinerary</h1>
          {renderCancunEvents()}
        </>
      )}

      {userEvent === 'Both' && (
        <>
          <h1>Houston Reception</h1>
          {renderHoustonEvents()}

          <h1>Cancun Wedding</h1>
          {renderCancunEvents()}
        </>
      )}

      {!userEvent && (
        <div className="error-message">
          <h1>Event Information Unavailable</h1>
          <p>We couldn't determine which events you're invited to. Please contact us for assistance.</p>
        </div>
      )}
    </div>
  );
};

export default Itinerary; 